import * as tslib_1 from "tslib";
/** @jsx jsx */
import { jsx, keyframes } from "@emotion/core";
import { useTheme } from "./Theme/Providers";
import PropTypes from "prop-types";
var animation = keyframes(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  0% {\n    background-position: -190px 0;\n  }\n  100% {\n    background-position: calc(190px + 100%) 0;\n  }\n"], ["\n  0% {\n    background-position: -190px 0;\n  }\n  100% {\n    background-position: calc(190px + 100%) 0;\n  }\n"])));
export var Skeleton = function (_a) {
    var baseColor = _a.baseColor, highlightColor = _a.highlightColor, _b = _a.animated, animated = _b === void 0 ? false : _b, _c = _a.duration, duration = _c === void 0 ? 1.2 : _c, other = tslib_1.__rest(_a, ["baseColor", "highlightColor", "animated", "duration"]);
    var theme = useTheme();
    var base = baseColor || theme.colors.background.tint2;
    var highlight = highlightColor || theme.colors.background.tint1;
    return (jsx("span", tslib_1.__assign({ css: {
            backgroundColor: base,
            backgroundImage: animated
                ? "linear-gradient(90deg, " + base + ", " + highlight + ", " + base + ")"
                : "none",
            backgroundSize: "190px 100%",
            backgroundRepeat: "no-repeat",
            borderRadius: theme.radii.sm,
            display: "inline-block",
            lineHeight: 1,
            width: "100%",
            animation: animated
                ? animation + " " + duration + "s linear infinite"
                : "none"
        } }, other), "\u200C"));
};
Skeleton.propTypes = {
    baseColor: PropTypes.string,
    highlightColor: PropTypes.string,
    duration: PropTypes.number
};
var templateObject_1;
